module.exports = __webpack_public_path__ + "static/media/icone-adicionar.2a687ed9.svg";